<button 
    type="button" 
    (click)="submit($event)" 
    [disabled]="isBusy() || disabled()"
    [class]="css()">
    
    @if (isBusy())
    {
        <div class="spinner-border spinner-border-sm" role="status" [class]="spinnerCss() ? spinnerCss() : 'text-white'"> <span class="visually-hidden">Loading...</span></div>                        
    }
    
    <ng-content></ng-content>

</button>